import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn } from "telia-front-react/grid";
import { Button } from "telia-front-react/button";
import ChangeDisturbanceStore from '@stores/ChangeDisturbanceStore';
import IncidentDisturbanceStore from '@stores/IncidentDisturbanceStore';
import ProblemDisturbanceStore from '@stores/ProblemDisturbanceStore';
import TranslateStore from '@stores/TranslateStore';
import { DisturbanceOffset } from '@config/DisturbanceConfig';
import { FilterState } from '@config/DisturbanceFilter';

interface DisturbancePaginationProps {
    store: ChangeDisturbanceStore | IncidentDisturbanceStore | ProblemDisturbanceStore;
    filter: FilterState;
    translateStore?: TranslateStore;
}

function DisturbancePagination(props: DisturbancePaginationProps) {
    const {
        translateStore: { translate },
        filter,
        store: { disturbances, isLoading }
    } = props;
    return !isLoading ? (
        <Grid align={['center-xs']}>
            <GridColumn width={['xs']}>
                <Button
                    text={`${translate('table.page.previous')  } 30`}
                    iconLeft="#arrow-left"
                    link={true}
                    type="employee"
                    onClick={() => props.store.fetchDisturbances(filter, disturbances.offset.prevPage)}
                    disabled={disturbances.offset.prevPage === null}
                />
            </GridColumn>
            <GridColumn width={['xs']} className="text-bold text-light">
                {getCurrentPage(disturbances.offset)}
            </GridColumn>
            <GridColumn width={['xs']}>
                <Button
                    text={`${translate('table.page.next')  } 30`}
                    iconRight="#arrow-right"
                    link={true}
                    type="employee"
                    onClick={() => props.store.fetchDisturbances(filter, disturbances.offset.nextPage)}
                    disabled={disturbances.offset.nextPage === null}
                />
            </GridColumn>
        </Grid>
    ) : null;
}

/**
 * Get range of disturbance documents count on the page (e.g 1-30)
 * @param offset Disturbance Offset
 */
function getCurrentPage(offset: DisturbanceOffset) {
    const current = offset.currentPage;
    const start = current + 1;
    const end = start + 29;
    return (
        `${start} - ${end}`
    );
}

export default inject('translateStore', 'store', 'filter')(observer(DisturbancePagination));
